import { higherCaseToCamelCase } from "ClientService";

export const getServerSettings = state => {
    const settings = {};
    for(const key in state.persistStore.settings) {
        settings[higherCaseToCamelCase(key)] = state.persistStore.settings[key];
    }
    return settings;
}